import {createContext, MutableRefObject, useContext} from 'react'

import {Metrika} from './types'

export const MetrikaContext = createContext<MutableRefObject<Metrika> | null>(null)

export const useMetrikaContext = (): MutableRefObject<Metrika> => {
  const contextValue = useContext(MetrikaContext)

  if (!contextValue) {
    throw new Error('context "MetrikaContext" not found')
  }

  return contextValue
}
